
<script setup>

  import { ref, watchEffect } from 'vue';

  import { useRouter } from 'vue-router';

  import { useRouteQuery } from '@vueuse/router';

  import zipCode from '../../state/zip-code';

  import Header from '../partials/header.vue';

  import Footer from '../partials/footer.vue';

  import Button from '../partials/button.vue';

  import DownloadBlock from '../partials/download-block.vue';

  import { exportPDF } from '../../pdfs/report';

  import mockupUrl from 'url:../../images/pop-health-data-mockup.png';

  const router = useRouter();

  const currentUrl = useRouteQuery( 'zip-code' );

  watchEffect( () => {
    
    zipCode.value = currentUrl.value;
  
  } );

  const downloadDisabled = ref( false );

  const downloadCompleted = ref( false );

  async function onClickDownload() {

    downloadDisabled.value = true;

    await exportPDF();

    downloadCompleted.value = true;

  }

</script>

<template>

  <Header />

  <main>

    <div class="

      px-6 py-14 bg-[url(./images/circle-pattern-blue.svg)]
      
      bg-no-repeat sm:px-8 sm:py-28 lg:px-24" style="background-position: center bottom 125px">

      <div class="max-w-6xl mx-auto">

        <div class="mb-12 text-center">

          <h1 class="mb-3 text-2xl leading-normal font-bold text-blue-primary sm:mb-5 sm:text-4xl">
            
            Thank you! Your report is ready for download:
          
          </h1>

          <div class="my-6 sm:my-10">

            <Button @click="onClickDownload" :disabled="downloadDisabled"
        
              class="px-10 py-3 text-blue-primary bg-green-bitter-lemon hover:bg-green-rio whitespace-nowrap
              
                disabled:text-white disabled:bg-black/40 disabled:cursor-not-allowed">

              <div v-if="downloadDisabled && !downloadCompleted" class="flex items-center justify-center">

                <p>Generating Your Custom Report</p>
                
                <svg class="ml-3 -mr-1 size-5 animate-spin text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">

                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>

                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                
                </svg>

              </div>

              <div v-else-if="downloadCompleted">

                <p>Thank you</p>

              </div>

              <div v-else>

                <p>Download Now</p>

              </div>

            </Button>

          </div>

          <p class="max-w-5xl mx-auto mb-10 text-base text-black sm:text-xl">

            You'll also receive a copy of the report via email.

          </p>

          <div class="flex justify-center">

            <img :src="mockupUrl" alt="bioMérieux Population Health Data Mockup" class="w-sm" />

          </div>

        </div>

        <div class="flex flex-col items-center lg:flex-row justify-center gap-8">

          <DownloadBlock 
          
            eyebrow="trends data"

            heading="Syndromic Trends"

            paragraph="View nationwide trends for various infectious pathogens related to syndromic diseases."
          
          >

            <template #button>

              <a href="https://syndromictrends.com/" target="_blank">visit syndromic trends</a>

            </template>

          </DownloadBlock>
            
          <DownloadBlock 
          
            eyebrow="trends report"

            heading="Real data. Real trends."

            paragraph="Access your free report today to track nationwide trends, and stay prepared for what's coming next."
          
          >
        
            <template #button>

              <a href="https://www.biomerieux.com/us/en/education/resource-hub/trends-reports.html" target="_blank">get my report</a>

            </template>
          
          </DownloadBlock>

        </div>

      </div>

    </div>

    <div class="px-6 py-12 bg-grey-mercury text-black text-center sm:px-8 lg:px-24">

      <div class="max-w-6xl mx-auto">

        <p class="mb-10">
          
          <strong>Looking to take action?</strong> Our product specialists are standing by to guide you to the right solution.

        </p>

        <Button class="text-white bg-blue-primary hover:bg-blue-prussian-hover px-10">

          <a href="https://info.biomerieux.com/clin_us_2025_population-health-tool_talk-to-sales">

            Schedule a Free Consultation

          </a>

        </Button>

      </div>

    </div>
  
  </main>

  <Footer />

</template>